import React from 'react'
import { Dialog, DialogTitle, DialogContent as dialogCont, DialogActions, Grid, Box, IconButton, styled, useTheme } from '@mui/material'
import CloseIcon from "@mui/icons-material/Close";

import { CustomCounterAppBar } from './'
////import { mainStyles } from '../styles/Main'
const DialogContent = styled(dialogCont)(({ theme }) => ({
    padding: "0 !important",
    '.MuiDialogContent-root':{
        padding: "0 !important"
    }
}));

const RootStyle = styled(Box)(({ theme }) => ({
    backgroundColor: "#FFF",
    minHeight: "calc(100vh - 120px)",
    margin: "0px auto",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    maxHeight: '100vh',
    width: "100%",
}));

const OutletWrapper = styled(Box)(({ theme }) => ({
    margin: "0px",
    backgroundColor: "#FFF",
    width: "100%",
    minHeight: "calc(100vh - 70px)",
    padding: "0.2em 0.5em",
    [theme.breakpoints.down(1200)]: {
        margin: "0px",
        padding: "0em",
    },
    [theme.breakpoints.down("sm")]: {
        margin: "0px",
        padding: "0em",
    },
    [theme.breakpoints.down("xs")]: {
        margin: "0px",
        padding: "0em",
    },
    overflowY: 'auto'
}));

const ContainerPrincipal = styled(Grid)(({ theme }) => ({
    margin: "0px 45px 0px 0px",
    display: 'grid !important',
    gridTemplateColumns: '20% 60% 20%',
    gridAutoRows: '100vh !important',
    overflowY: 'hidden !important',
    '&::-webkit-scrollbar': {
        width: '0',
        background: 'transparent',
    },
    overflowX: 'hidden',
    position: 'fixed',
    top: 0,
    bottom: 0,
    width: '100%',
    [theme.breakpoints.only('xs')]: {
        gridTemplateColumns: '100%',
    },
    [theme.breakpoints.only('sm')]: {
        gridTemplateColumns: '10% 80% 10%',
    },
    [theme.breakpoints.only('md')]: {
        gridTemplateColumns: '15% 70% 15%',
    },
    [theme.breakpoints.only('lg')]: {
        gridTemplateColumns: '20% 60% 20%',
    },
    [theme.breakpoints.only('xl')]: {
        gridTemplateColumns: '20% 60% 20%',
    },
    background: "#f1f1f1"
}));

const LateralBox = styled(Box)(({ theme }) => ({
    background: "#f2f2f2",
    [theme.breakpoints.only('xs')]: {
        display: 'none'
    },
    [theme.breakpoints.only('sm')]: {
        display: 'block !important'
    },
    [theme.breakpoints.only('md')]: {
        display: 'block !important'
    },
    [theme.breakpoints.only('lg')]: {
        display: 'block !important'
    },
    [theme.breakpoints.only('xl')]: {
        display: 'block !important'
    },
}));

export const GenericDialog = props => {
    return (
        <Dialog fullScreen open={props.open} onClose={props.onClose}>
            <ContainerPrincipal>
                <LateralBox />
                <RootStyle>
                    {props.viewMenu ?
                       <CustomCounterAppBar
                            viewButtonClose={(props.viewButtonClose == null ||
                                props.viewButtonClose == undefined ? true : props.viewButtonClose)}
                            closeClick={props.onClose}
                            initialStep={props.initialStep}
                            endingStep={props.endingStep}
                        />
                        : <Box sx={{
                            background: "#FFFFFF",
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'flex-end',
                            borderBottom: '1px solid gray',
                        }}>
                            <IconButton type="submit" onClick={props.onClose}>
                                <CloseIcon />
                            </IconButton>
                        </Box>}
                    <OutletWrapper>
                        {props.title ? <DialogTitle sx={{textAlign: 'center'}}>{props.title}</DialogTitle> : null}
                        {props.content ? <DialogContent sx={{'MuiDialogContent-root':{
                            padding: 0
                        }}}>{props.content}</DialogContent> 
                            : null}
                        {props.actions ? <DialogActions>{props.actions}</DialogActions> : null}
                    </OutletWrapper>
                </RootStyle>
                <LateralBox />
            </ContainerPrincipal>
        </Dialog >
    )
}